import React from "react";
import { Link } from "react-router-dom";
import { FaLinkedin, FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import logo from "../assets/logo.png";

const Footer = () => {
  return (
    <footer className="relative bg-[#0a192f] text-white pt-16 pb-8 px-6">

      {/* Gradient Line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-purple-500 to-pink-500"></div>

      <div className="max-w-6xl mx-auto grid md:grid-cols-4 gap-10">

        {/* BRAND */}
        <div>
          <img src={logo} alt="TheLogicWaves" className="w-32 mb-4" />
          <p className="text-gray-400 text-sm">
            TheLogicWaves is a digital agency focused on building modern,
            scalable, and high-performance solutions.
          </p>
        </div>

        {/* LINKS */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-purple-400">
            Quick Links
          </h3>
          <ul className="space-y-2 text-gray-400">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/portfolio">Portfolio</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* SERVICES */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-purple-400">
            Services
          </h3>
          <ul className="space-y-2 text-gray-400">
            <li>Web Development</li>
            <li>UI/UX Design</li>
            <li>SEO Optimization</li>
            <li>Brand Strategy</li>
          </ul>
        </div>

        {/* CONTACT + SOCIAL */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-purple-400">
            Contact
          </h3>

          <ul className="space-y-2 text-gray-400 text-sm">
            <li>Email: thelogicwaves@gmail.com</li>
            <li>Phone: +92 300 9609342</li>
            <li>Location: Pakistan</li>
          </ul>

          {/* SOCIAL ICONS */}
          <div className="flex gap-4 mt-5 text-xl">

            <a
              href="https://www.linkedin.com/company/thelogicwaves/?viewAsMember=true"
              target="_blank"
              rel="noreferrer"
              className="hover:text-blue-400 hover:scale-110 transition"
            >
              <FaLinkedin />
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61567827534480"
              target="_blank"
              rel="noreferrer"
              className="hover:text-blue-500 hover:scale-110 transition"
            >
              <FaFacebook />
            </a>

            <a
              href="https://www.instagram.com/thelogicwaves2024/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-pink-400 hover:scale-110 transition"
            >
              <FaInstagram />
            </a>

            <a
              href="https://wa.me/923009609342"
              target="_blank"
              rel="noreferrer"
              className="hover:text-green-400 hover:scale-110 transition"
            >
              <FaWhatsapp />
            </a>

          </div>
        </div>

      </div>

      {/* BOTTOM */}
      <div className="text-center text-gray-500 text-sm mt-12 border-t border-gray-700 pt-6">
        © {new Date().getFullYear()} TheLogicWaves. All rights reserved.
      </div>

    </footer>
  );
};

export default Footer;